import React, {useCallback} from 'react'
import {DatabaseIcon, DocumentTextIcon, GlobeIcon, KeyIcon} from "@heroicons/react/outline";
import {TooltipCategory} from "../../../themes/SharedStyledComponent";
import {DatamodelDto} from "@biron-data/bqconf";
import {useGetPopoverRowWithIcon} from "./DatamodelRights.utils";
import Language from "../../../language";

const getDatamodelRightsGlobalPopover = (
  getPopoverRowWithIcon: (isEnabled: boolean, languageArgs: {key: string, args?: any}, Icon: React.FunctionComponent, starCount?: number) => JSX.Element,
  datamodel: Pick<DatamodelDto, "alias">,
 hasDashboardViewerAccess: boolean,
 hasDashboardExplorerAccess: boolean,) => {
  return <>
    <TooltipCategory>{Language.get('admin.datamodels.popup.titlePrefix')} {datamodel.alias}</TooltipCategory>
    {[
      {
        key: "dataAccess",
        isEnabled: hasDashboardViewerAccess,
        Icon: DatabaseIcon
      },
      {
        key: "publicDashboardsAccess",
        isEnabled: hasDashboardViewerAccess,
        Icon: GlobeIcon
      },
      {
        key: "personalDashboardsAccess",
        isEnabled: hasDashboardExplorerAccess,
        Icon: KeyIcon
      },
      {
        key: "pluginsAccess",
        isEnabled: hasDashboardExplorerAccess,
        Icon: DocumentTextIcon
      }
    ].map(element => getPopoverRowWithIcon(
      element.isEnabled,
      {key: `admin.datamodels.popup.${element.key}`, args: hasDashboardExplorerAccess},
      element.Icon))}
  </>
}

export const useGetDatamodelRightsGlobalPopover = (
) => {
  const getPopoverRowWithIcon = useGetPopoverRowWithIcon()
  return useCallback((
    datamodel: Pick<DatamodelDto, "alias">,
    hasDashboardViewerAccess: boolean,
    hasDashboardExplorerAccess: boolean,
  ) => {
    return getDatamodelRightsGlobalPopover(getPopoverRowWithIcon, datamodel, hasDashboardViewerAccess, hasDashboardExplorerAccess)
  }, [getPopoverRowWithIcon])
}
